
export const photos = [
    "/images/home/campo.jpg",
    "/images/home/hivision_1.jpg",
    "/images/home/mikrotik_1.jpg",
    "/images/home/camara.png",
    "/images/home/puntopunto.png",
    "/images/home/redes.png",
];


